<template>
  <div id="hwlist">
    <Table height="400" :columns="hwColumns" :data="hwlistShow" :loading="loading"></Table>
    <Page style="float: right;margin: 5px" :current="pageInfo.current"
          :total="pageInfo.total" :page-size="pageInfo.size"
          @on-change="changePage"></Page>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import _ from 'lodash'

export default {
  data () {
    return {
      loading: false,
      pageInfo: {current: 1, size: 5},
      hwlist: [],
      hwlistShow: [],
      hwColumns: [
        {
          title: '编号',
          sortable: true,
          key: 'hwid'
        }, {
          title: '课程',
          key: 'course'
        }, {
          title: '标题',
          key: 'title'
        }, {
          title: '内容',
          key: 'content'
        }, {
          title: '课程',
          key: 'course'
        }, {
          title: '结束时间',
          render: (h, params) => {
            let d = new Date(params.row.endtime);
            return h('div', d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate());
          }
        }, {
          title: '老师',
          render: (h, params) => {
            return h('div', params.row.teacherInfo.name);
          }
        }]
    }
  },
  methods: {
    getHwlist: function () {
      var vueThis = this
      vueThis.loading = true;
      let funcName = 'getAllHomework';
      vueThis.$store.dispatch('simulateCallNew', {funcName: funcName}).then((ret) => {
        vueThis.loading = false;
        console.log('getAllHomework', ret);
        vueThis.hwlist = JSON.parse(ret);
        vueThis.changePage(1);
      }, (error) => {
        vueThis.loading = false;
        vueThis.showErr('获取作业列表' + error);
      });
    },
    changePage (pageNum) {
      let vueThis = this;
      vueThis.loading = true;
      vueThis.hwlistShow = [];
      let p = vueThis.pageInfo;
      p.current = !pageNum ? 1 : pageNum;
      let maxPage = Math.ceil(p.total / p.size);
      p.current = _.min([p.current, maxPage])
      p.total = _.get(vueThis.hwlist, 'length', 0);

      let start = (p.current - 1) * p.size;
      let end = _.min([p.current * p.size, p.total]);

      vueThis.hwlistShow = _.slice(vueThis.hwlist, start, end);
      vueThis.loading = false;
    }
  },
  created () {
    this.getHwlist()
  },
  computed: mapState([
    'user'
  ])
}
</script>

<style>
  #hwlist{
  }
</style>



// WEBPACK FOOTER //
// src/components/base-homework-list.vue